/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data:{
        is_follow:false,
        is_self:true,
        locked:false,
    },
    mounted(){
        if(!qk_global.author_id) return;
        this.$http.post(qk_rest_url+'checkFollow','user_id='+qk_global.author_id).then(res=>{
            this.is_self = res.data.is_self
            this.is_follow = res.data.is_follow

            if (window.postAuthor) {
                window.postAuthor.is_follow = res.data.is_follow;
            }
        }).catch((err) => {
            qkShowApiError(err, '加载关注状态失败');
        })
    },
    methods:{
        onFollow(){
            if(!qktoken) return this.$createModal('login');
            if(this.locked == true) return
            this.locked = true
            
            this.$http.post(qk_rest_url+'userFollow','user_id='+qk_global.author_id).then(res=>{
                this.is_follow = !this.is_follow
                
                if (window.postAuthor) {
                    window.postAuthor.is_follow = this.is_follow;
                }
                
                this.locked = false
                
                this.$message({ message: '操作成功' , type: 'success' });
            }).catch(err=>{
                this.locked = false
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
        whisper(){
            if(!qktoken) return this.$createModal('login');
            window.location.href = `message?whisper=${qk_global.author_id}`;
        }
    }
};
